import { createTheme, MantineColorsTuple } from '@mantine/core';

/**
 * Кастомная палитра visuator lime
 * Базовый цвет: #8bc34a
 */
const visuatorLime: MantineColorsTuple = [
  '#f4f9ec', // 0 - lightest
  '#e5f0d4', // 1
  '#c8e1a4', // 2
  '#aad170', // 3
  '#8bc34a', // 4 - primary (base)
  '#7cb342', // 5 - darker (hover)
  '#6da03a', // 6
  '#5d8d32', // 7
  '#4e7a2a', // 8
  '#3f6722', // 9 - darkest
];

/**
 * Тема в стиле visuator.ru
 * - Лаймовый primary цвет
 * - Тёплые нейтральные тона
 * - Скруглённые углы
 */
export const theme = createTheme({
  primaryColor: 'visuatorLime',
  colors: {
    visuatorLime,
  },
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  headings: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontWeight: '600',
  },
  radius: {
    xs: '4px',
    sm: '6px',
    md: '8px',
    lg: '12px',
    xl: '16px',
  },
  defaultRadius: 'md',
  components: {
    Button: {
      defaultProps: {
        radius: 'md',
      },
      styles: {
        root: {
          fontWeight: 500,
          transition: 'all 0.2s ease',
        },
      },
    },
    Paper: {
      defaultProps: {
        radius: 'lg',
      },
    },
    TextInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    PinInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    Stepper: {
      styles: {
        stepIcon: {
          transition: 'all 0.2s ease',
        },
      },
    },
  },
});
